import { LocaleStore } from "@/store";

export function translate(language: string, message: string) : string {
    try {
        const keys = message.split('.');
        
        let t = JSON.parse(JSON.stringify(LocaleStore.data));
        for (const key of keys)
            t = t[key];

        return t[language];
    }
    catch(e) {
        return '';
    }
}